import { observer } from "mobx-react-lite";
import ShopHistoryTable from "./components/ShopHistoryTable";
import { ShopHistoryStorageModel } from "e.sic-platform.webclient/src/services/shop/ShopHistoryStorage";
import { useState } from "react";
import { api } from "e.sic-platform.webclient/src/services/api/ApiService";

export default observer(function ShopUsagePage() {
    const [shopHistoryStorage] = useState(() =>
        ShopHistoryStorageModel.create({}, { api })
    );
    return (
        <>
            <ShopHistoryTable shopHistoryStorage={shopHistoryStorage}/>
        </>
    );
});